import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeUrl'
})
export class SafeUrlPipe implements PipeTransform {

  private domSanitizer: DomSanitizer = inject(DomSanitizer);

  transform(value: string): unknown {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
  }

}
